import { ReorderSectionsParams } from '../../hooks/useCatalogSectionsDnd.types';

export interface CatalogSectionTab {
  id: string;
  name: string;
  itemsCount: number;
}

export enum CatalogSectionTabsTrigger {
  NONE = 'none',
  PLUS = 'plus',
  MORE = 'more',
}

export interface CatalogSectionTabsBarProps {
  sections: CatalogSectionTab[];
  activeSectionId: string;
  canManage: boolean;
  isManagementOpen: boolean;
  onSelect: (sectionId: string) => void;
  onOpenManagement: (anchor: HTMLElement | null) => void;
  onReorder: (params: ReorderSectionsParams) => void;
}

export interface UseCatalogSectionTabsBarParams {
  sections: CatalogSectionTab[];
  activeSectionId: string;
  canManage: boolean;
  onSelect: (sectionId: string) => void;
}
